import { createApp } from 'vue'
import { surveyPlugin } from 'survey-vue3-ui'
import App from './App.vue'
import router from './router'
import store from './store'
import './assets/css/main.css'

createApp(App).use(router).use(store).use(surveyPlugin).mount('#app')
